<template>
  <div>
    <b-card v-if="userIsAParent" title="Card Title" no-body>
      <div v-if="childrenFiltered.length > 0">
        <b-card-header header-tag="nav">
          <b-nav card-header tabs align="center">
            <b-nav-item :active="showPoints" class="h-auto" @click="showPoints = true">
              Stars
            </b-nav-item>
            <b-nav-item :active="!showPoints" class="h-auto" @click="showPoints = false">
              Goals
            </b-nav-item>
          </b-nav>
        </b-card-header>
        <b-card-body>
          <!--  Stars Section -->
          <child-stars v-if="showPoints" />
          <!--  Goals Section -->
          <child-goals v-else />
        </b-card-body>
      </div>
      <div v-else>
        <empty-module
          class="empty-module"
          :title="'No child have been added yet.'"
          :icon="'face'"
          :goFunction="() => $router.push('/register-child')"
        />
      </div>
    </b-card>

    <!--  Child Section -->
    <section v-else class="mt-3 container">
      <stars-progress :allStars="getUserScoreAll" :availableStars="getUserScore" />
    </section>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import childStars from '@/components/progress/child/childStars';
import starsProgress from '@/components/progress/starsProgress.vue';
import childGoals from '@/components/progress/child/childGoals';
import emptyModule from '../../components/general/emptyModule.vue';

export default {
  components: {
    childStars,
    starsProgress,
    childGoals,
    emptyModule,
  },
  data() {
    return {
      showPoints: true,
      calendarUniqueValue: '',
    };
  },
  methods: {},
  computed: {
    ...mapGetters('user', ['getUserId', 'getUserScore', 'getUserScoreAll', 'userIsAParent']),
    ...mapGetters('parent', ['getChildrenData']),
    childrenFiltered() {
      return this.getChildrenData.filter((child) => child.child_enabled);
    },
  },
};
</script>
